import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.75 3.75a.75.75 0 0 0-1.5 0v7.5h-7.5a.75.75 0 0 0 0 1.5h7.5v7.5a.75.75 0 0 0 1.5 0v-7.5h7.5a.75.75 0 0 0 0-1.5h-7.5z" />
  </>
);

const Plus = Icon('plus', svgContents);

export default Plus;
